import React, { useState } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import videoThumbnail from '../assets/video-thumbnail.jpg';

function VideoPlayer() {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        aspectRatio: '16 / 9',
        overflow: 'hidden',
        borderRadius: '2px',
        bgcolor: '#050404',
        border: '1px solid rgba(248, 241, 231, 0.18)',
      }}
    >
      {isPlaying ? (
        <iframe
          src="https://www.youtube.com/embed/2tIiEo3EUCA?autoplay=1"
          title="Malpractice Band live performance"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
          }}
        />
      ) : (
        <ButtonBase
          onClick={() => setIsPlaying(true)}
          aria-label="Play Malpractice Band live performance"
          sx={{
            width: '100%',
            height: '100%',
            display: 'block',
            position: 'relative',
            textAlign: 'left',
            '&:hover img': {
              transform: 'scale(1.03)',
              filter: 'saturate(1.1) brightness(1.03)',
            },
            '&:hover .play-control': {
              bgcolor: '#ffd06f',
              transform: 'scale(1.06)',
            },
          }}
        >
          <Box
            component="img"
            src={videoThumbnail}
            alt=""
            width="480"
            height="360"
            sx={{
              display: 'block',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 350ms ease, filter 350ms ease',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(180deg, rgba(11, 9, 9, 0.08) 0%, rgba(11, 9, 9, 0.58) 100%)',
            }}
          >
            <Box
              className="play-control"
              sx={{
                width: { xs: 64, md: 76 },
                height: { xs: 64, md: 76 },
                borderRadius: '50%',
                bgcolor: 'secondary.main',
                color: '#110c0a',
                display: 'grid',
                placeItems: 'center',
                transition: 'background-color 180ms ease, transform 180ms ease',
              }}
            >
              <PlayArrowRoundedIcon sx={{ fontSize: { xs: 42, md: 50 } }} />
            </Box>
          </Box>
          <Typography
            sx={{
              position: 'absolute',
              left: { xs: 18, md: 24 },
              bottom: { xs: 16, md: 20 },
              color: 'text.primary',
              fontWeight: 700,
              fontSize: { xs: '0.9rem', md: '1rem' },
            }}
          >
            Play live performance
          </Typography>
        </ButtonBase>
      )}
    </Box>
  );
}

export default VideoPlayer;
